// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legends_legend__1Cs3N","item":"Legends_item__1HOfP","line":"Legends_line__1-ed9","parameter":"Legends_parameter__EkHFG","referenceLine":"Legends_referenceLine__2XkwR"};